import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-search',
	templateUrl: './icon-search.component.svg',
})
export class IconSearchComponent {}
